import { IDimensions2D, IOfsset2D, ISideOffsets } from "./Common"
import { GlassOrderString } from "./Layers"

export interface IPrintedObject extends IDimensions2D {
  positioning: IOfsset2D
  isHole: boolean
  isTransparent: boolean
  isCircle: boolean
  radius: number
  title?: string
  colors: string[]
  wImg: boolean
  imgFileName: string | null
  img64: string | null
  formHidden: boolean
}

//export const defaultLogo = { width: 1, height: 1, isHole: false, isTransparent: false, colors: ['']};
export const defaultLogo: IPrintedObject = {
  width: 10,
  height: 10,
  positioning: { centralOffsetX: 0, centralOffsetY: 0 } as IOfsset2D,
  isHole: false,
  isTransparent: false,
  isCircle: false,
  radius: 5,
  colors: [""],
  wImg: false,
  title: "Object 1",
  formHidden: false,
  img64: null,
  imgFileName: null,
}

export interface IPrinting {
  withPrinting: boolean
  withLogo: boolean
  onGlass: GlassOrderString
  frameThickness: ISideOffsets
  objects: IPrintedObject[]
  color: string
  doublePrint: boolean
}
